import { createAction } from 'utils/redux';

import { LOAD_REFERENTIALS } from './events';

export const loadReferentials = createAction(LOAD_REFERENTIALS);
